export default __webpack_public_path__ + "static/media/clock-circle-time.5574fc13.svg";